import Index from '../views/Index'


export default [
    {path: '/', name: 'Index', component: Index},
    {path: '/callback', name: 'cb', component: Index},

]
